<bp-modal>
	<ng-template>
		<bp-current-subscription-management
			(subscriptionPlanSuccessfullyDowngraded)="closeModal()"
			(subscriptionPlanSuccessfullyPurchased)="closeModal()"
		></bp-current-subscription-management>
	</ng-template>
</bp-modal>
